import { Info } from "lucide-react";

// =============================================================================
// AddressPickHint
//
// Gentle, NON-BLOCKING nudge shown under an address field when we don't yet
// have map coordinates for it — i.e. the staff member typed an address but
// didn't choose one from the Google dropdown (or picked a saved/curated
// address that has no stored pin). Coordinates let the trip dispatch reliably
// in TripLink; when they're absent the server geocodes the address as a
// fallback, so this only *encourages* picking from the dropdown — it never
// blocks the booking. Replaces the old manual "City, State ZIP" input.
// =============================================================================

export function AddressPickHint() {
  return (
    <p
      role="status"
      className="flex items-start gap-1.5 rounded-lg border border-warning/40 bg-warning/10 px-2.5 py-1.5 text-xs text-foreground/80"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-warning" aria-hidden="true" />
      <span>
        Pick the address from the dropdown so dispatch gets its exact location.
      </span>
    </p>
  );
}
